import { computed, observable, set } from "mobx";
import moment from "moment";

class YoutubeAuthentication {
  @observable youtubeAuthenticationId;

  @observable channelId;

  @observable customerId;

  @observable username;

  @observable apiSyncedDts;

  /**
   *
   * @returns {null|moment.Moment}
   */
  @computed
  get syncedDate() {
    if (!this.apiSyncedDts) {
      return null;
    }
    return moment.unix(this.apiSyncedDts);
  }

  constructor(data) {
    if (data) {
      set(this, data);
    }
  }
}
export default YoutubeAuthentication;
